var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 208,
    viewBox: "0 0 208 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.62162 0H0V5.62162H5.62162V0Z",
    fill: "#0B0C0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2432 0H5.62162V5.62162H11.2432V0Z",
    fill: "#0B0C0D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8649 0H11.2432V5.62162H16.8649V0Z",
    fill: "#0B0C0D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4865 0H16.8649V5.62162H22.4865V0Z",
    fill: "#0B0C0D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1081 0H22.4865V5.62162H28.1081V0Z",
    fill: "#0B0C0D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7297 0H28.1081V5.62162H33.7297V0Z",
    fill: "#0B0C0D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3514 0H33.7297V5.62162H39.3514V0Z",
    fill: "#0B0C0D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5946 0H44.973V5.62162H50.5946V0Z",
    fill: "#0B0C0D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2162 0H50.5946V5.62162H56.2162V0Z",
    fill: "#0B0C0D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7027 0H73.0811V5.62162H78.7027V0Z",
    fill: "#0B0C0D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3243 0H78.7027V5.62162H84.3243V0Z",
    fill: "#0B0C0D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.946 0H84.3243V5.62162H89.946V0Z",
    fill: "#0B0C0D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5676 0H89.946V5.62162H95.5676V0Z",
    fill: "#0B0C0D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M106.811 0H101.189V5.62162H106.811V0Z",
    fill: "#0B0C0D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M118.054 0H112.432V5.62162H118.054V0Z",
    fill: "#0B0C0D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M123.676 0H118.054V5.62162H123.676V0Z",
    fill: "#0B0C0D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M129.297 0H123.676V5.62162H129.297V0Z",
    fill: "#0B0C0D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M134.919 0H129.297V5.62162H134.919V0Z",
    fill: "#0B0C0D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M140.541 0H134.919V5.62162H140.541V0Z",
    fill: "#0B0C0D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M146.162 0H140.541V5.62162H146.162V0Z",
    fill: "#0B0C0D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M151.784 0H146.162V5.62162H151.784V0Z",
    fill: "#0B0C0D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M157.405 0H151.784V5.62162H157.405V0Z",
    fill: "#0B0C0D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M163.027 0H157.405V5.62162H163.027V0Z",
    fill: "#0B0C0D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M174.27 0H168.649V5.62162H174.27V0Z",
    fill: "#0B0C0D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M179.892 0H174.27V5.62162H179.892V0Z",
    fill: "#0B0C0D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M185.514 0H179.892V5.62162H185.514V0Z",
    fill: "#0B0C0D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M191.135 0H185.514V5.62162H191.135V0Z",
    fill: "#0B0C0D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M196.757 0H191.135V5.62162H196.757V0Z",
    fill: "#0B0C0D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M202.378 0H196.757V5.62162H202.378V0Z",
    fill: "#0B0C0D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M208 0H202.378V5.62162H208V0Z",
    fill: "#0B0C0D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62162 5.62162H0V11.2432H5.62162V5.62162Z",
    fill: "#0B0C0D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3514 5.62162H33.7297V11.2432H39.3514V5.62162Z",
    fill: "#0B0C0D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8378 5.62162H56.2162V11.2432H61.8378V5.62162Z",
    fill: "#0B0C0D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4595 5.62162H61.8378V11.2432H67.4595V5.62162Z",
    fill: "#0B0C0D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3243 5.62162H78.7027V11.2432H84.3243V5.62162Z",
    fill: "#0B0C0D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M89.946 5.62162H84.3243V11.2432H89.946V5.62162Z",
    fill: "#0B0C0D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M101.189 5.62162H95.5676L95.5676 11.2432H101.189L101.189 5.62162Z",
    fill: "#0B0C0D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M118.054 5.62162H112.432V11.2432H118.054V5.62162Z",
    fill: "#0B0C0D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M146.162 5.62162H140.541V11.2432H146.162V5.62162Z",
    fill: "#0B0C0D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M174.27 5.62162H168.649V11.2432H174.27V5.62162Z",
    fill: "#0B0C0D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M208 5.62162H202.378V11.2432H208V5.62162Z",
    fill: "#0B0C0D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62162 11.2432H0V16.8649H5.62162V11.2432Z",
    fill: "#0B0C0D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8649 11.2432H11.2432V16.8649H16.8649V11.2432Z",
    fill: "#0B0C0D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4865 11.2432H16.8649V16.8649H22.4865V11.2432Z",
    fill: "#0B0C0D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1081 11.2432H22.4865V16.8649H28.1081V11.2432Z",
    fill: "#0B0C0D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3514 11.2432H33.7297V16.8649H39.3514V11.2432Z",
    fill: "#0B0C0D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5946 11.2432H44.973V16.8649H50.5946V11.2432Z",
    fill: "#0B0C0D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2162 11.2432H50.5946V16.8649H56.2162V11.2432Z",
    fill: "#0B0C0D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4595 11.2432H61.8378V16.8649H67.4595V11.2432Z",
    fill: "#0B0C0D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0811 11.2432H67.4595V16.8649H73.0811V11.2432Z",
    fill: "#0B0C0D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M89.946 11.2432H84.3243L84.3243 16.8649H89.946V11.2432Z",
    fill: "#0B0C0D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M118.054 11.2432H112.432V16.8649H118.054V11.2432Z",
    fill: "#0B0C0D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M140.541 11.2432H134.919V16.8649H140.541V11.2432Z",
    fill: "#0B0C0D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M163.027 11.2432H157.405V16.8649H163.027V11.2432Z",
    fill: "#0B0C0D"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M174.27 11.2432H168.649V16.8649H174.27V11.2432Z",
    fill: "#0B0C0D"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M185.514 11.2432H179.892V16.8649H185.514V11.2432Z",
    fill: "#0B0C0D"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M191.135 11.2432H185.514V16.8649H191.135V11.2432Z",
    fill: "#0B0C0D"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M196.757 11.2432H191.135V16.8649H196.757V11.2432Z",
    fill: "#0B0C0D"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M208 11.2432H202.378V16.8649H208V11.2432Z",
    fill: "#0B0C0D"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62162 16.8649H0V22.4865H5.62162V16.8649Z",
    fill: "#0B0C0D"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8649 16.8649H11.2432V22.4865H16.8649V16.8649Z",
    fill: "#0B0C0D"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4865 16.8649H16.8649V22.4865H22.4865V16.8649Z",
    fill: "#0B0C0D"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1081 16.8649H22.4865V22.4865H28.1081V16.8649Z",
    fill: "#0B0C0D"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3514 16.8649H33.7297V22.4865H39.3514V16.8649Z",
    fill: "#0B0C0D"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5946 16.8649H44.973V22.4865H50.5946V16.8649Z",
    fill: "#0B0C0D"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2162 16.8649H50.5946V22.4865H56.2162V16.8649Z",
    fill: "#0B0C0D"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4595 16.8649H61.8378V22.4865H67.4595V16.8649Z",
    fill: "#0B0C0D"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3243 16.8649H78.7027V22.4865H84.3243L84.3243 16.8649Z",
    fill: "#0B0C0D"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M89.946 16.8649H84.3243L84.3243 22.4865H89.946V16.8649Z",
    fill: "#0B0C0D"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5676 16.8649H89.946V22.4865H95.5676V16.8649Z",
    fill: "#0B0C0D"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M118.054 16.8649H112.432V22.4865H118.054V16.8649Z",
    fill: "#0B0C0D"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M123.676 16.8649H118.054V22.4865H123.676V16.8649Z",
    fill: "#0B0C0D"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M129.297 16.8649H123.676V22.4865H129.297V16.8649Z",
    fill: "#0B0C0D"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M140.541 16.8649H134.919V22.4865H140.541V16.8649Z",
    fill: "#0B0C0D"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M157.405 16.8649H151.784V22.4865H157.405V16.8649Z",
    fill: "#0B0C0D"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M174.27 16.8649H168.649V22.4865H174.27V16.8649Z",
    fill: "#0B0C0D"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M185.514 16.8649H179.892V22.4865H185.514V16.8649Z",
    fill: "#0B0C0D"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M191.135 16.8649H185.514V22.4865H191.135V16.8649Z",
    fill: "#0B0C0D"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M196.757 16.8649H191.135V22.4865H196.757V16.8649Z",
    fill: "#0B0C0D"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M208 16.8649H202.378V22.4865H208V16.8649Z",
    fill: "#0B0C0D"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62162 22.4865H0V28.1081H5.62162V22.4865Z",
    fill: "#0B0C0D"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8649 22.4865H11.2432V28.1081H16.8649V22.4865Z",
    fill: "#0B0C0D"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4865 22.4865H16.8649V28.1081H22.4865V22.4865Z",
    fill: "#0B0C0D"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1081 22.4865H22.4865V28.1081H28.1081V22.4865Z",
    fill: "#0B0C0D"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3514 22.4865H33.7297V28.1081H39.3514V22.4865Z",
    fill: "#0B0C0D"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5946 22.4865H44.973V28.1081H50.5946V22.4865Z",
    fill: "#0B0C0D"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2162 22.4865H50.5946V28.1081H56.2162V22.4865Z",
    fill: "#0B0C0D"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7027 22.4865H73.0811V28.1081H78.7027V22.4865Z",
    fill: "#0B0C0D"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M89.946 22.4865H84.3243L84.3243 28.1081H89.946V22.4865Z",
    fill: "#0B0C0D"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M101.189 22.4865H95.5676L95.5676 28.1081H101.189V22.4865Z",
    fill: "#0B0C0D"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M106.811 22.4865H101.189V28.1081H106.811V22.4865Z",
    fill: "#0B0C0D"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M118.054 22.4865H112.432V28.1081H118.054V22.4865Z",
    fill: "#0B0C0D"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M151.784 22.4865H146.162V28.1081H151.784V22.4865Z",
    fill: "#0B0C0D"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M157.405 22.4865H151.784V28.1081H157.405V22.4865Z",
    fill: "#0B0C0D"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M163.027 22.4865H157.405V28.1081H163.027V22.4865Z",
    fill: "#0B0C0D"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M174.27 22.4865H168.649V28.1081H174.27V22.4865Z",
    fill: "#0B0C0D"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M185.514 22.4865H179.892V28.1081H185.514V22.4865Z",
    fill: "#0B0C0D"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M191.135 22.4865H185.514V28.1081H191.135V22.4865Z",
    fill: "#0B0C0D"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M196.757 22.4865H191.135V28.1081H196.757V22.4865Z",
    fill: "#0B0C0D"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M208 22.4865H202.378V28.1081H208V22.4865Z",
    fill: "#0B0C0D"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62162 28.1081H0V33.7297H5.62162V28.1081Z",
    fill: "#0B0C0D"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3514 28.1081H33.7297V33.7297H39.3514V28.1081Z",
    fill: "#0B0C0D"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5946 28.1081H44.973V33.7297H50.5946V28.1081Z",
    fill: "#0B0C0D"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8378 28.1081H56.2162V33.7297H61.8378V28.1081Z",
    fill: "#0B0C0D"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7027 28.1081H73.0811V33.7297H78.7027V28.1081Z",
    fill: "#0B0C0D"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3243 28.1081H78.7027V33.7297H84.3243L84.3243 28.1081Z",
    fill: "#0B0C0D"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M89.946 28.1081H84.3243L84.3243 33.7297H89.946V28.1081Z",
    fill: "#0B0C0D"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5676 28.1081H89.946V33.7297H95.5676L95.5676 28.1081Z",
    fill: "#0B0C0D"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M101.189 28.1081H95.5676L95.5676 33.7297H101.189V28.1081Z",
    fill: "#0B0C0D"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M118.054 28.1081H112.432V33.7297H118.054V28.1081Z",
    fill: "#0B0C0D"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M123.676 28.1081H118.054V33.7297H123.676V28.1081Z",
    fill: "#0B0C0D"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M129.297 28.1081H123.676V33.7297H129.297V28.1081Z",
    fill: "#0B0C0D"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M134.919 28.1081H129.297V33.7297H134.919V28.1081Z",
    fill: "#0B0C0D"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M140.541 28.1081H134.919V33.7297H140.541V28.1081Z",
    fill: "#0B0C0D"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M146.162 28.1081H140.541V33.7297H146.162V28.1081Z",
    fill: "#0B0C0D"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M157.405 28.1081H151.784V33.7297H157.405V28.1081Z",
    fill: "#0B0C0D"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M174.27 28.1081H168.649V33.7297H174.27V28.1081Z",
    fill: "#0B0C0D"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M208 28.1081H202.378V33.7297H208V28.1081Z",
    fill: "#0B0C0D"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62162 33.7297H0V39.3514H5.62162V33.7297Z",
    fill: "#0B0C0D"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2432 33.7297H5.62162V39.3514H11.2432V33.7297Z",
    fill: "#0B0C0D"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8649 33.7297H11.2432V39.3514H16.8649V33.7297Z",
    fill: "#0B0C0D"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4865 33.7297H16.8649V39.3514H22.4865V33.7297Z",
    fill: "#0B0C0D"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1081 33.7297H22.4865V39.3514H28.1081V33.7297Z",
    fill: "#0B0C0D"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7297 33.7297H28.1081V39.3514H33.7297V33.7297Z",
    fill: "#0B0C0D"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3514 33.7297H33.7297V39.3514H39.3514V33.7297Z",
    fill: "#0B0C0D"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5946 33.7297H44.973V39.3514H50.5946V33.7297Z",
    fill: "#0B0C0D"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8378 33.7297H56.2162V39.3514H61.8378V33.7297Z",
    fill: "#0B0C0D"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0811 33.7297H67.4595V39.3514H73.0811L73.0811 33.7297Z",
    fill: "#0B0C0D"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3243 33.7297H78.7027V39.3514H84.3243V33.7297Z",
    fill: "#0B0C0D"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5676 33.7297H89.946L89.9459 39.3514H95.5676V33.7297Z",
    fill: "#0B0C0D"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M106.811 33.7297H101.189L101.189 39.3514H106.811V33.7297Z",
    fill: "#0B0C0D"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M118.054 33.7297H112.432V39.3514H118.054V33.7297Z",
    fill: "#0B0C0D"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M129.297 33.7297H123.676V39.3514H129.297V33.7297Z",
    fill: "#0B0C0D"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M140.541 33.7297H134.919V39.3514H140.541V33.7297Z",
    fill: "#0B0C0D"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M151.784 33.7297H146.162V39.3514H151.784V33.7297Z",
    fill: "#0B0C0D"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M163.027 33.7297H157.405V39.3514H163.027V33.7297Z",
    fill: "#0B0C0D"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M174.27 33.7297H168.649V39.3514H174.27V33.7297Z",
    fill: "#0B0C0D"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M179.892 33.7297H174.27V39.3514H179.892V33.7297Z",
    fill: "#0B0C0D"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M185.514 33.7297H179.892V39.3514H185.514V33.7297Z",
    fill: "#0B0C0D"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M191.135 33.7297H185.514V39.3514H191.135V33.7297Z",
    fill: "#0B0C0D"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M196.757 33.7297H191.135V39.3514H196.757V33.7297Z",
    fill: "#0B0C0D"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M202.378 33.7297H196.757V39.3514H202.378V33.7297Z",
    fill: "#0B0C0D"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M208 33.7297H202.378V39.3514H208V33.7297Z",
    fill: "#0B0C0D"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8378 39.3514H56.2162V44.973H61.8378V39.3514Z",
    fill: "#0B0C0D"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4595 39.3514H61.8378V44.973H67.4595L67.4595 39.3514Z",
    fill: "#0B0C0D"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0811 39.3514H67.4595L67.4595 44.973H73.0811V39.3514Z",
    fill: "#0B0C0D"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3243 39.3514H78.7027V44.973H84.3243V39.3514Z",
    fill: "#0B0C0D"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5676 39.3514H89.9459V44.973H95.5676V39.3514Z",
    fill: "#0B0C0D"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M101.189 39.3514H95.5676V44.973H101.189L101.189 39.3514Z",
    fill: "#0B0C0D"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M112.432 39.3514H106.811V44.973H112.432V39.3514Z",
    fill: "#0B0C0D"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M118.054 39.3514H112.432V44.973H118.054V39.3514Z",
    fill: "#0B0C0D"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M123.676 39.3514H118.054V44.973H123.676V39.3514Z",
    fill: "#0B0C0D"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M129.297 39.3514H123.676V44.973H129.297V39.3514Z",
    fill: "#0B0C0D"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M151.784 39.3514H146.162V44.973H151.784V39.3514Z",
    fill: "#0B0C0D"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M157.405 39.3514H151.784V44.973H157.405V39.3514Z",
    fill: "#0B0C0D"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M163.027 39.3514H157.405V44.973H163.027V39.3514Z",
    fill: "#0B0C0D"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8649 44.973H11.2432V50.5946H16.8649V44.973Z",
    fill: "#0B0C0D"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4865 44.973H16.8649V50.5946H22.4865V44.973Z",
    fill: "#0B0C0D"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1081 44.973H22.4865V50.5946H28.1081V44.973Z",
    fill: "#0B0C0D"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7297 44.973H28.1081V50.5946H33.7297V44.973Z",
    fill: "#0B0C0D"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3514 44.973H33.7297V50.5946H39.3514V44.973Z",
    fill: "#0B0C0D"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M44.973 44.973H39.3514V50.5946H44.973V44.973Z",
    fill: "#0B0C0D"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2162 44.973H50.5946V50.5946H56.2162V44.973Z",
    fill: "#0B0C0D"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8378 44.973H56.2162V50.5946H61.8378V44.973Z",
    fill: "#0B0C0D"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7027 44.973H73.0811L73.0811 50.5946H78.7027V44.973Z",
    fill: "#0B0C0D"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5676 44.973H89.9459V50.5946H95.5676V44.973Z",
    fill: "#0B0C0D"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M101.189 44.973H95.5676V50.5946H101.189V44.973Z",
    fill: "#0B0C0D"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M106.811 44.973H101.189V50.5946H106.811V44.973Z",
    fill: "#0B0C0D"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M118.054 44.973H112.432V50.5946H118.054V44.973Z",
    fill: "#0B0C0D"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M123.676 44.973H118.054V50.5946H123.676V44.973Z",
    fill: "#0B0C0D"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M129.297 44.973H123.676V50.5946H129.297V44.973Z",
    fill: "#0B0C0D"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M134.919 44.973H129.297V50.5946H134.919V44.973Z",
    fill: "#0B0C0D"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M140.541 44.973H134.919V50.5946H140.541V44.973Z",
    fill: "#0B0C0D"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M146.162 44.973H140.541V50.5946H146.162V44.973Z",
    fill: "#0B0C0D"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M157.405 44.973H151.784V50.5946H157.405V44.973Z",
    fill: "#0B0C0D"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M168.649 44.973H163.027V50.5946H168.649V44.973Z",
    fill: "#0B0C0D"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M179.892 44.973H174.27V50.5946H179.892V44.973Z",
    fill: "#0B0C0D"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M185.514 44.973H179.892V50.5946H185.514V44.973Z",
    fill: "#0B0C0D"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M191.135 44.973H185.514V50.5946H191.135V44.973Z",
    fill: "#0B0C0D"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M196.757 44.973H191.135V50.5946H196.757V44.973Z",
    fill: "#0B0C0D"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M208 44.973H202.378V50.5946H208V44.973Z",
    fill: "#0B0C0D"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2432 50.5946H5.62162V56.2162H11.2432V50.5946Z",
    fill: "#0B0C0D"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8649 50.5946H11.2432V56.2162H16.8649V50.5946Z",
    fill: "#0B0C0D"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4865 50.5946H16.8649V56.2162H22.4865V50.5946Z",
    fill: "#0B0C0D"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2162 50.5946H50.5946V56.2162H56.2162V50.5946Z",
    fill: "#0B0C0D"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8378 50.5946H56.2162V56.2162H61.8378V50.5946Z",
    fill: "#0B0C0D"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4595 50.5946H61.8378V56.2162H67.4595V50.5946Z",
    fill: "#0B0C0D"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0811 50.5946H67.4595V56.2162H73.0811L73.0811 50.5946Z",
    fill: "#0B0C0D"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3243 50.5946H78.7027V56.2162H84.3243V50.5946Z",
    fill: "#0B0C0D"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9459 50.5946H84.3243V56.2162H89.946L89.9459 50.5946Z",
    fill: "#0B0C0D"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5676 50.5946H89.9459L89.946 56.2162H95.5676V50.5946Z",
    fill: "#0B0C0D"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M101.189 50.5946H95.5676V56.2162H101.189V50.5946Z",
    fill: "#0B0C0D"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M112.432 50.5946H106.811V56.2162H112.432V50.5946Z",
    fill: "#0B0C0D"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M118.054 50.5946H112.432V56.2162H118.054V50.5946Z",
    fill: "#0B0C0D"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M129.297 50.5946H123.676V56.2162H129.297V50.5946Z",
    fill: "#0B0C0D"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M151.784 50.5946H146.162V56.2162H151.784V50.5946Z",
    fill: "#0B0C0D"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M157.405 50.5946H151.784V56.2162H157.405V50.5946Z",
    fill: "#0B0C0D"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M163.027 50.5946H157.405V56.2162H163.027V50.5946Z",
    fill: "#0B0C0D"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M168.649 50.5946H163.027V56.2162H168.649V50.5946Z",
    fill: "#0B0C0D"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M174.27 50.5946H168.649V56.2162H174.27V50.5946Z",
    fill: "#0B0C0D"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M191.135 50.5946H185.514V56.2162H191.135V50.5946Z",
    fill: "#0B0C0D"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8649 56.2162H11.2432V61.8378H16.8649V56.2162Z",
    fill: "#0B0C0D"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1081 56.2162H22.4865V61.8378H28.1081V56.2162Z",
    fill: "#0B0C0D"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3514 56.2162H33.7297V61.8378H39.3514V56.2162Z",
    fill: "#0B0C0D"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M44.973 56.2162H39.3514V61.8378H44.973V56.2162Z",
    fill: "#0B0C0D"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5946 56.2162H44.973V61.8378H50.5946V56.2162Z",
    fill: "#0B0C0D"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2162 56.2162H50.5946V61.8378H56.2162V56.2162Z",
    fill: "#0B0C0D"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8378 56.2162H56.2162V61.8378H61.8378V56.2162Z",
    fill: "#0B0C0D"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0811 56.2162H67.4595L67.4595 61.8378H73.0811V56.2162Z",
    fill: "#0B0C0D"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3243 56.2162H78.7027V61.8378H84.3243V56.2162Z",
    fill: "#0B0C0D"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M112.432 56.2162H106.811V61.8378H112.432V56.2162Z",
    fill: "#0B0C0D"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M118.054 56.2162H112.432V61.8378H118.054V56.2162Z",
    fill: "#0B0C0D"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M123.676 56.2162H118.054V61.8378H123.676V56.2162Z",
    fill: "#0B0C0D"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M151.784 56.2162H146.162V61.8378H151.784V56.2162Z",
    fill: "#0B0C0D"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M157.405 56.2162H151.784V61.8378H157.405V56.2162Z",
    fill: "#0B0C0D"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M163.027 56.2162H157.405V61.8378H163.027V56.2162Z",
    fill: "#0B0C0D"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M168.649 56.2162H163.027V61.8378H168.649V56.2162Z",
    fill: "#0B0C0D"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M174.27 56.2162H168.649V61.8378H174.27V56.2162Z",
    fill: "#0B0C0D"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M196.757 56.2162H191.135V61.8378H196.757V56.2162Z",
    fill: "#0B0C0D"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62162 61.8378H0V67.4595H5.62162V61.8378Z",
    fill: "#0B0C0D"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8649 61.8378H11.2432V67.4595H16.8649V61.8378Z",
    fill: "#0B0C0D"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7297 61.8378H28.1081V67.4595H33.7297V61.8378Z",
    fill: "#0B0C0D"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5946 61.8378H44.973V67.4595H50.5946V61.8378Z",
    fill: "#0B0C0D"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4595 61.8378H61.8378V67.4595H67.4595L67.4595 61.8378Z",
    fill: "#0B0C0D"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5676 61.8378H89.9459V67.4595H95.5676V61.8378Z",
    fill: "#0B0C0D"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M112.432 61.8378H106.811V67.4595H112.432V61.8378Z",
    fill: "#0B0C0D"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M123.676 61.8378H118.054V67.4595H123.676V61.8378Z",
    fill: "#0B0C0D"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M134.919 61.8378H129.297V67.4595H134.919V61.8378Z",
    fill: "#0B0C0D"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M140.541 61.8378H134.919V67.4595H140.541V61.8378Z",
    fill: "#0B0C0D"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M151.784 61.8378H146.162V67.4595H151.784V61.8378Z",
    fill: "#0B0C0D"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M157.405 61.8378H151.784V67.4595H157.405V61.8378Z",
    fill: "#0B0C0D"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M163.027 61.8378H157.405V67.4595H163.027V61.8378Z",
    fill: "#0B0C0D"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M174.27 61.8378H168.649V67.4595H174.27V61.8378Z",
    fill: "#0B0C0D"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M185.514 61.8378H179.892V67.4595H185.514V61.8378Z",
    fill: "#0B0C0D"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M191.135 61.8378H185.514V67.4595H191.135V61.8378Z",
    fill: "#0B0C0D"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M196.757 61.8378H191.135V67.4595H196.757V61.8378Z",
    fill: "#0B0C0D"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M202.378 61.8378H196.757V67.4595H202.378V61.8378Z",
    fill: "#0B0C0D"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62162 67.4595H0V73.0811H5.62162V67.4595Z",
    fill: "#0B0C0D"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8649 67.4595H11.2432V73.0811H16.8649V67.4595Z",
    fill: "#0B0C0D"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4865 67.4595L16.8649 67.4595V73.0811H22.4865V67.4595Z",
    fill: "#0B0C0D"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1081 67.4595L22.4865 67.4595V73.0811H28.1081V67.4595Z",
    fill: "#0B0C0D"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3514 67.4595L33.7297 67.4595V73.0811H39.3514V67.4595Z",
    fill: "#0B0C0D"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M44.973 67.4595L39.3514 67.4595V73.0811H44.973V67.4595Z",
    fill: "#0B0C0D"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8378 67.4595L56.2162 67.4595V73.0811H61.8378V67.4595Z",
    fill: "#0B0C0D"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7027 67.4595H73.0811V73.0811H78.7027V67.4595Z",
    fill: "#0B0C0D"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5676 67.4595H89.9459V73.0811H95.5676V67.4595Z",
    fill: "#0B0C0D"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M101.189 67.4595L95.5676 67.4595V73.0811H101.189V67.4595Z",
    fill: "#0B0C0D"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M112.432 67.4595H106.811V73.0811H112.432V67.4595Z",
    fill: "#0B0C0D"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M140.541 67.4595H134.919V73.0811H140.541V67.4595Z",
    fill: "#0B0C0D"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M163.027 67.4595H157.405V73.0811H163.027V67.4595Z",
    fill: "#0B0C0D"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M174.27 67.4595H168.649V73.0811H174.27V67.4595Z",
    fill: "#0B0C0D"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M179.892 67.4595H174.27V73.0811H179.892V67.4595Z",
    fill: "#0B0C0D"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M185.514 67.4595H179.892V73.0811H185.514V67.4595Z",
    fill: "#0B0C0D"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M196.757 67.4595H191.135V73.0811H196.757V67.4595Z",
    fill: "#0B0C0D"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M208 67.4595L202.378 67.4595V73.0811H208V67.4595Z",
    fill: "#0B0C0D"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2432 73.0811H5.62162V78.7027H11.2432V73.0811Z",
    fill: "#0B0C0D"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8649 73.0811H11.2432V78.7027H16.8649V73.0811Z",
    fill: "#0B0C0D"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4865 73.0811H16.8649V78.7027H22.4865V73.0811Z",
    fill: "#0B0C0D"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7297 73.0811H28.1081V78.7027H33.7297V73.0811Z",
    fill: "#0B0C0D"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M44.973 73.0811H39.3514V78.7027H44.973V73.0811Z",
    fill: "#0B0C0D"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2162 73.0811L50.5946 73.0811V78.7027H56.2162V73.0811Z",
    fill: "#0B0C0D"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4595 73.0811L61.8378 73.0811V78.7027H67.4595V73.0811Z",
    fill: "#0B0C0D"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0811 73.0811L67.4595 73.0811V78.7027H73.0811L73.0811 73.0811Z",
    fill: "#0B0C0D"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3243 73.0811L78.7027 73.0811V78.7027H84.3243V73.0811Z",
    fill: "#0B0C0D"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5676 73.0811H89.9459V78.7027H95.5676V73.0811Z",
    fill: "#0B0C0D"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M118.054 73.0811L112.432 73.0811V78.7027H118.054V73.0811Z",
    fill: "#0B0C0D"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M123.676 73.0811H118.054V78.7027H123.676V73.0811Z",
    fill: "#0B0C0D"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M134.919 73.0811L129.297 73.0811V78.7027H134.919V73.0811Z",
    fill: "#0B0C0D"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M140.541 73.0811H134.919V78.7027H140.541V73.0811Z",
    fill: "#0B0C0D"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M146.162 73.0811L140.541 73.0811V78.7027H146.162V73.0811Z",
    fill: "#0B0C0D"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M151.784 73.0811H146.162V78.7027H151.784V73.0811Z",
    fill: "#0B0C0D"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M168.649 73.0811H163.027V78.7027H168.649V73.0811Z",
    fill: "#0B0C0D"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M174.27 73.0811H168.649V78.7027H174.27V73.0811Z",
    fill: "#0B0C0D"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M185.514 73.0811H179.892V78.7027H185.514V73.0811Z",
    fill: "#0B0C0D"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M191.135 73.0811H185.514V78.7027H191.135V73.0811Z",
    fill: "#0B0C0D"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M196.757 73.0811H191.135V78.7027H196.757V73.0811Z",
    fill: "#0B0C0D"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62162 78.7027H0V84.3243H5.62162V78.7027Z",
    fill: "#0B0C0D"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2432 78.7027H5.62162V84.3243H11.2432V78.7027Z",
    fill: "#0B0C0D"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1081 78.7027H22.4865V84.3243H28.1081V78.7027Z",
    fill: "#0B0C0D"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7297 78.7027H28.1081V84.3243H33.7297V78.7027Z",
    fill: "#0B0C0D"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3514 78.7027H33.7297V84.3243H39.3514V78.7027Z",
    fill: "#0B0C0D"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M44.973 78.7027H39.3514V84.3243H44.973V78.7027Z",
    fill: "#0B0C0D"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5946 78.7027H44.973V84.3243H50.5946V78.7027Z",
    fill: "#0B0C0D"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9459 78.7027H84.3243L84.3243 84.3243H89.946L89.9459 78.7027Z",
    fill: "#0B0C0D"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M101.189 78.7027H95.5676L95.5676 84.3243H101.189V78.7027Z",
    fill: "#0B0C0D"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M106.811 78.7027H101.189V84.3243H106.811V78.7027Z",
    fill: "#0B0C0D"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M112.432 78.7027H106.811V84.3243H112.432V78.7027Z",
    fill: "#0B0C0D"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M118.054 78.7027H112.432V84.3243H118.054V78.7027Z",
    fill: "#0B0C0D"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M163.027 78.7027H157.405V84.3243H163.027V78.7027Z",
    fill: "#0B0C0D"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M179.892 78.7027H174.27V84.3243H179.892V78.7027Z",
    fill: "#0B0C0D"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62162 84.3243H0V89.946H5.62162V84.3243Z",
    fill: "#0B0C0D"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2432 84.3243H5.62162V89.946H11.2432V84.3243Z",
    fill: "#0B0C0D"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7297 84.3243H28.1081V89.946H33.7297V84.3243Z",
    fill: "#0B0C0D"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2162 84.3243L50.5946 84.3243V89.946H56.2162V84.3243Z",
    fill: "#0B0C0D"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8378 84.3243H56.2162V89.946H61.8378V84.3243Z",
    fill: "#0B0C0D"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4595 84.3243H61.8378V89.946H67.4595V84.3243Z",
    fill: "#0B0C0D"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0811 84.3243H67.4595V89.946H73.0811V84.3243Z",
    fill: "#0B0C0D"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3243 84.3243L78.7027 84.3243V89.946H84.3243L84.3243 84.3243Z",
    fill: "#0B0C0D"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M89.946 84.3243H84.3243L84.3243 89.946H89.946V84.3243Z",
    fill: "#0B0C0D"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M101.189 84.3243H95.5676V89.946H101.189V84.3243Z",
    fill: "#0B0C0D"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M129.297 84.3243H123.676V89.946H129.297V84.3243Z",
    fill: "#0B0C0D"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M134.919 84.3243H129.297V89.946H134.919V84.3243Z",
    fill: "#0B0C0D"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M146.162 84.3243H140.541V89.946H146.162V84.3243Z",
    fill: "#0B0C0D"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M151.784 84.3243H146.162V89.946H151.784V84.3243Z",
    fill: "#0B0C0D"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M157.405 84.3243L151.784 84.3243V89.946H157.405V84.3243Z",
    fill: "#0B0C0D"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M163.027 84.3243H157.405V89.946H163.027V84.3243Z",
    fill: "#0B0C0D"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M174.27 84.3243L168.649 84.3243V89.946H174.27V84.3243Z",
    fill: "#0B0C0D"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M179.892 84.3243H174.27V89.946H179.892V84.3243Z",
    fill: "#0B0C0D"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M185.514 84.3243L179.892 84.3243V89.946H185.514V84.3243Z",
    fill: "#0B0C0D"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M191.135 84.3243H185.514V89.946H191.135V84.3243Z",
    fill: "#0B0C0D"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62162 89.946H0V95.5676H5.62162V89.946Z",
    fill: "#0B0C0D"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8649 89.9459L11.2432 89.946V95.5676H16.8649V89.9459Z",
    fill: "#0B0C0D"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1081 89.946L22.4865 89.9459V95.5676H28.1081V89.946Z",
    fill: "#0B0C0D"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3514 89.9459L33.7297 89.946V95.5676H39.3514V89.9459Z",
    fill: "#0B0C0D"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5946 89.946L44.973 89.9459V95.5676H50.5946V89.946Z",
    fill: "#0B0C0D"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8378 89.946H56.2162V95.5676H61.8378V89.946Z",
    fill: "#0B0C0D"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0811 89.946H67.4595L67.4595 95.5676H73.0811V89.946Z",
    fill: "#0B0C0D"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7027 89.946H73.0811V95.5676H78.7027V89.946Z",
    fill: "#0B0C0D"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M89.946 89.946H84.3243L84.3243 95.5676H89.946V89.946Z",
    fill: "#0B0C0D"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M101.189 89.946H95.5676V95.5676H101.189V89.946Z",
    fill: "#0B0C0D"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M112.432 89.9459H106.811V95.5676H112.432V89.9459Z",
    fill: "#0B0C0D"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M123.676 89.946L118.054 89.9459V95.5676H123.676V89.946Z",
    fill: "#0B0C0D"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M129.297 89.946H123.676V95.5676H129.297V89.946Z",
    fill: "#0B0C0D"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M140.541 89.946H134.919V95.5676H140.541V89.946Z",
    fill: "#0B0C0D"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M151.784 89.946H146.162V95.5676H151.784V89.946Z",
    fill: "#0B0C0D"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M168.649 89.946H163.027V95.5676H168.649V89.946Z",
    fill: "#0B0C0D"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M174.27 89.946H168.649V95.5676H174.27V89.946Z",
    fill: "#0B0C0D"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M191.135 89.946H185.514V95.5676H191.135V89.946Z",
    fill: "#0B0C0D"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M202.378 89.9459H196.757V95.5676H202.378V89.9459Z",
    fill: "#0B0C0D"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2432 95.5676H5.62162V101.189H11.2432V95.5676Z",
    fill: "#0B0C0D"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4865 95.5676H16.8649V101.189H22.4865V95.5676Z",
    fill: "#0B0C0D"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1081 95.5676H22.4865V101.189H28.1081V95.5676Z",
    fill: "#0B0C0D"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7297 95.5676H28.1081V101.189H33.7297V95.5676Z",
    fill: "#0B0C0D"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M44.973 95.5676H39.3514V101.189H44.973V95.5676Z",
    fill: "#0B0C0D"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2162 95.5676H50.5946V101.189H56.2162V95.5676Z",
    fill: "#0B0C0D"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8378 95.5676H56.2162V101.189H61.8378V95.5676Z",
    fill: "#0B0C0D"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0811 95.5676H67.4595V101.189H73.0811V95.5676Z",
    fill: "#0B0C0D"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M118.054 95.5676H112.432V101.189H118.054V95.5676Z",
    fill: "#0B0C0D"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M123.676 95.5676H118.054V101.189H123.676V95.5676Z",
    fill: "#0B0C0D"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M129.297 95.5676H123.676V101.189H129.297V95.5676Z",
    fill: "#0B0C0D"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M134.919 95.5676H129.297V101.189H134.919V95.5676Z",
    fill: "#0B0C0D"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M163.027 95.5676L157.405 95.5676V101.189H163.027V95.5676Z",
    fill: "#0B0C0D"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M208 95.5676L202.378 95.5676V101.189H208V95.5676Z",
    fill: "#0B0C0D"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2432 101.189H5.62162V106.811H11.2432V101.189Z",
    fill: "#0B0C0D"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4865 101.189H16.8649V106.811H22.4865V101.189Z",
    fill: "#0B0C0D"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1081 101.189H22.4865V106.811H28.1081V101.189Z",
    fill: "#0B0C0D"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3514 101.189H33.7297V106.811H39.3514V101.189Z",
    fill: "#0B0C0D"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M44.973 101.189H39.3514V106.811H44.973V101.189Z",
    fill: "#0B0C0D"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2162 101.189H50.5946V106.811H56.2162V101.189Z",
    fill: "#0B0C0D"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7027 101.189L73.0811 101.189L73.0811 106.811H78.7027V101.189Z",
    fill: "#0B0C0D"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3243 101.189H78.7027V106.811H84.3243V101.189Z",
    fill: "#0B0C0D"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5676 101.189H89.9459V106.811H95.5676V101.189Z",
    fill: "#0B0C0D"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M112.432 101.189L106.811 101.189V106.811H112.432V101.189Z",
    fill: "#0B0C0D"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M123.676 101.189H118.054V106.811H123.676V101.189Z",
    fill: "#0B0C0D"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M134.919 101.189H129.297V106.811H134.919V101.189Z",
    fill: "#0B0C0D"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M146.162 101.189H140.541V106.811H146.162V101.189Z",
    fill: "#0B0C0D"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M174.27 101.189H168.649V106.811H174.27V101.189Z",
    fill: "#0B0C0D"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M185.514 101.189H179.892V106.811H185.514V101.189Z",
    fill: "#0B0C0D"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M202.378 101.189L196.757 101.189V106.811H202.378V101.189Z",
    fill: "#0B0C0D"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1081 106.811H22.4865V112.432H28.1081V106.811Z",
    fill: "#0B0C0D"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8378 106.811H56.2162V112.432H61.8378V106.811Z",
    fill: "#0B0C0D"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4595 106.811H61.8378V112.432H67.4595V106.811Z",
    fill: "#0B0C0D"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0811 106.811H67.4595V112.432H73.0811L73.0811 106.811Z",
    fill: "#0B0C0D"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7027 106.811H73.0811L73.0811 112.432H78.7027V106.811Z",
    fill: "#0B0C0D"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M123.676 106.811H118.054V112.432H123.676V106.811Z",
    fill: "#0B0C0D"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M151.784 106.811H146.162V112.432H151.784V106.811Z",
    fill: "#0B0C0D"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M157.405 106.811H151.784V112.432H157.405V106.811Z",
    fill: "#0B0C0D"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M163.027 106.811H157.405V112.432H163.027V106.811Z",
    fill: "#0B0C0D"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M168.649 106.811H163.027V112.432H168.649V106.811Z",
    fill: "#0B0C0D"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M179.892 106.811H174.27V112.432H179.892V106.811Z",
    fill: "#0B0C0D"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M185.514 106.811H179.892V112.432H185.514V106.811Z",
    fill: "#0B0C0D"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2432 112.432H5.62162V118.054H11.2432V112.432Z",
    fill: "#0B0C0D"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4865 112.432H16.8649V118.054H22.4865V112.432Z",
    fill: "#0B0C0D"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1081 112.432H22.4865V118.054H28.1081V112.432Z",
    fill: "#0B0C0D"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3514 112.432H33.7297V118.054H39.3514V112.432Z",
    fill: "#0B0C0D"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2162 112.432H50.5946V118.054H56.2162V112.432Z",
    fill: "#0B0C0D"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4595 112.432H61.8378V118.054H67.4595V112.432Z",
    fill: "#0B0C0D"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0811 112.432H67.4595V118.054H73.0811V112.432Z",
    fill: "#0B0C0D"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7027 112.432H73.0811V118.054H78.7027V112.432Z",
    fill: "#0B0C0D"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5676 112.432H89.9459V118.054H95.5676V112.432Z",
    fill: "#0B0C0D"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M106.811 112.432H101.189V118.054H106.811V112.432Z",
    fill: "#0B0C0D"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M118.054 112.432H112.432V118.054H118.054V112.432Z",
    fill: "#0B0C0D"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M123.676 112.432H118.054V118.054H123.676V112.432Z",
    fill: "#0B0C0D"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M129.297 112.432H123.676V118.054H129.297V112.432Z",
    fill: "#0B0C0D"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M146.162 112.432H140.541V118.054H146.162V112.432Z",
    fill: "#0B0C0D"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M157.405 112.432H151.784V118.054H157.405V112.432Z",
    fill: "#0B0C0D"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M168.649 112.432H163.027V118.054H168.649V112.432Z",
    fill: "#0B0C0D"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M174.27 112.432H168.649V118.054H174.27V112.432Z",
    fill: "#0B0C0D"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M179.892 112.432H174.27V118.054H179.892V112.432Z",
    fill: "#0B0C0D"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M185.514 112.432H179.892V118.054H185.514V112.432Z",
    fill: "#0B0C0D"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M196.757 112.432H191.135V118.054H196.757V112.432Z",
    fill: "#0B0C0D"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62162 118.054H0V123.676H5.62162V118.054Z",
    fill: "#0B0C0D"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8649 118.054H11.2432V123.676H16.8649V118.054Z",
    fill: "#0B0C0D"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1081 118.054H22.4865V123.676H28.1081V118.054Z",
    fill: "#0B0C0D"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7297 118.054H28.1081V123.676H33.7297V118.054Z",
    fill: "#0B0C0D"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M44.973 118.054H39.3514V123.676H44.973V118.054Z",
    fill: "#0B0C0D"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5946 118.054H44.973V123.676H50.5946V118.054Z",
    fill: "#0B0C0D"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2162 118.054H50.5946V123.676H56.2162V118.054Z",
    fill: "#0B0C0D"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8378 118.054H56.2162V123.676H61.8378V118.054Z",
    fill: "#0B0C0D"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4595 118.054H61.8378V123.676H67.4595V118.054Z",
    fill: "#0B0C0D"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5676 118.054H89.9459V123.676H95.5676V118.054Z",
    fill: "#0B0C0D"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M112.432 118.054H106.811V123.676H112.432V118.054Z",
    fill: "#0B0C0D"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M123.676 118.054H118.054V123.676H123.676V118.054Z",
    fill: "#0B0C0D"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M129.297 118.054H123.676V123.676H129.297V118.054Z",
    fill: "#0B0C0D"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M134.919 118.054H129.297V123.676H134.919V118.054Z",
    fill: "#0B0C0D"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M140.541 118.054H134.919V123.676H140.541V118.054Z",
    fill: "#0B0C0D"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M146.162 118.054H140.541V123.676H146.162V118.054Z",
    fill: "#0B0C0D"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M157.405 118.054H151.784V123.676H157.405V118.054Z",
    fill: "#0B0C0D"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M185.514 118.054H179.892V123.676H185.514V118.054Z",
    fill: "#0B0C0D"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M191.135 118.054H185.514V123.676H191.135V118.054Z",
    fill: "#0B0C0D"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M196.757 118.054H191.135V123.676H196.757V118.054Z",
    fill: "#0B0C0D"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M202.378 118.054H196.757V123.676H202.378V118.054Z",
    fill: "#0B0C0D"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62162 123.676H0V129.297H5.62162V123.676Z",
    fill: "#0B0C0D"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8649 123.676H11.2432V129.297H16.8649V123.676Z",
    fill: "#0B0C0D"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4865 123.676H16.8649V129.297H22.4865V123.676Z",
    fill: "#0B0C0D"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1081 123.676H22.4865V129.297H28.1081V123.676Z",
    fill: "#0B0C0D"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3514 123.676H33.7297V129.297H39.3514V123.676Z",
    fill: "#0B0C0D"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M44.973 123.676H39.3514V129.297H44.973V123.676Z",
    fill: "#0B0C0D"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8378 123.676H56.2162V129.297H61.8378V123.676Z",
    fill: "#0B0C0D"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0811 123.676H67.4595L67.4595 129.297H73.0811V123.676Z",
    fill: "#0B0C0D"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3243 123.676H78.7027V129.297H84.3243V123.676Z",
    fill: "#0B0C0D"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5676 123.676H89.9459V129.297H95.5676V123.676Z",
    fill: "#0B0C0D"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M106.811 123.676H101.189V129.297H106.811V123.676Z",
    fill: "#0B0C0D"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M112.432 123.676H106.811V129.297H112.432V123.676Z",
    fill: "#0B0C0D"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M118.054 123.676H112.432V129.297H118.054V123.676Z",
    fill: "#0B0C0D"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M123.676 123.676H118.054V129.297H123.676V123.676Z",
    fill: "#0B0C0D"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M134.919 123.676H129.297V129.297H134.919V123.676Z",
    fill: "#0B0C0D"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M146.162 123.676H140.541V129.297H146.162V123.676Z",
    fill: "#0B0C0D"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M163.027 123.676H157.405V129.297H163.027V123.676Z",
    fill: "#0B0C0D"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M174.27 123.676H168.649V129.297H174.27V123.676Z",
    fill: "#0B0C0D"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M185.514 123.676H179.892V129.297H185.514V123.676Z",
    fill: "#0B0C0D"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M196.757 123.676H191.135V129.297H196.757V123.676Z",
    fill: "#0B0C0D"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M202.378 123.676H196.757V129.297H202.378V123.676Z",
    fill: "#0B0C0D"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62162 129.297H0V134.919H5.62162V129.297Z",
    fill: "#0B0C0D"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4865 129.297H16.8649V134.919H22.4865V129.297Z",
    fill: "#0B0C0D"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1081 129.297H22.4865V134.919H28.1081V129.297Z",
    fill: "#0B0C0D"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M44.973 129.297H39.3514V134.919H44.973V129.297Z",
    fill: "#0B0C0D"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5946 129.297H44.973V134.919H50.5946V129.297Z",
    fill: "#0B0C0D"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2162 129.297H50.5946V134.919H56.2162V129.297Z",
    fill: "#0B0C0D"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0811 129.297H67.4595V134.919H73.0811V129.297Z",
    fill: "#0B0C0D"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7027 129.297H73.0811V134.919H78.7027V129.297Z",
    fill: "#0B0C0D"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5676 129.297H89.9459V134.919H95.5676V129.297Z",
    fill: "#0B0C0D"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M101.189 129.297H95.5676V134.919H101.189L101.189 129.297Z",
    fill: "#0B0C0D"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M118.054 129.297H112.432V134.919H118.054V129.297Z",
    fill: "#0B0C0D"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M123.676 129.297H118.054V134.919H123.676V129.297Z",
    fill: "#0B0C0D"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M134.919 129.297H129.297V134.919H134.919V129.297Z",
    fill: "#0B0C0D"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M140.541 129.297H134.919V134.919H140.541V129.297Z",
    fill: "#0B0C0D"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M146.162 129.297H140.541V134.919H146.162V129.297Z",
    fill: "#0B0C0D"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M168.649 129.297H163.027V134.919H168.649V129.297Z",
    fill: "#0B0C0D"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M179.892 129.297H174.27V134.919H179.892V129.297Z",
    fill: "#0B0C0D"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M191.135 129.297H185.514V134.919H191.135V129.297Z",
    fill: "#0B0C0D"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M202.378 129.297H196.757V134.919H202.378V129.297Z",
    fill: "#0B0C0D"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62162 134.919H0V140.541H5.62162V134.919Z",
    fill: "#0B0C0D"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3514 134.919H33.7297V140.541H39.3514V134.919Z",
    fill: "#0B0C0D"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2162 134.919H50.5946V140.541H56.2162V134.919Z",
    fill: "#0B0C0D"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4595 134.919H61.8378V140.541H67.4595L67.4595 134.919Z",
    fill: "#0B0C0D"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0811 134.919H67.4595L67.4595 140.541H73.0811V134.919Z",
    fill: "#0B0C0D"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7027 134.919H73.0811V140.541H78.7027V134.919Z",
    fill: "#0B0C0D"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5676 134.919H89.9459V140.541H95.5676V134.919Z",
    fill: "#0B0C0D"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M106.811 134.919H101.189L101.189 140.541H106.811V134.919Z",
    fill: "#0B0C0D"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M118.054 134.919H112.432V140.541H118.054V134.919Z",
    fill: "#0B0C0D"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M140.541 134.919H134.919V140.541H140.541V134.919Z",
    fill: "#0B0C0D"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M151.784 134.919H146.162V140.541H151.784V134.919Z",
    fill: "#0B0C0D"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M157.405 134.919H151.784V140.541H157.405V134.919Z",
    fill: "#0B0C0D"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M163.027 134.919H157.405V140.541H163.027V134.919Z",
    fill: "#0B0C0D"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M179.892 134.919H174.27V140.541H179.892V134.919Z",
    fill: "#0B0C0D"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M196.757 134.919H191.135V140.541H196.757V134.919Z",
    fill: "#0B0C0D"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M208 134.919H202.378V140.541H208V134.919Z",
    fill: "#0B0C0D"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62162 140.541H0V146.162H5.62162V140.541Z",
    fill: "#0B0C0D"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2432 140.541H5.62162V146.162H11.2432V140.541Z",
    fill: "#0B0C0D"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4865 140.541H16.8649V146.162H22.4865V140.541Z",
    fill: "#0B0C0D"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1081 140.541H22.4865V146.162H28.1081V140.541Z",
    fill: "#0B0C0D"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7297 140.541H28.1081V146.162H33.7297V140.541Z",
    fill: "#0B0C0D"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5946 140.541H44.973V146.162H50.5946V140.541Z",
    fill: "#0B0C0D"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8378 140.541H56.2162V146.162H61.8378V140.541Z",
    fill: "#0B0C0D"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0811 140.541H67.4595L67.4595 146.162H73.0811V140.541Z",
    fill: "#0B0C0D"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5676 140.541H89.9459V146.162H95.5676V140.541Z",
    fill: "#0B0C0D"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M101.189 140.541H95.5676V146.162H101.189L101.189 140.541Z",
    fill: "#0B0C0D"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M118.054 140.541H112.432V146.162H118.054V140.541Z",
    fill: "#0B0C0D"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M140.541 140.541H134.919V146.162H140.541V140.541Z",
    fill: "#0B0C0D"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M163.027 140.541H157.405V146.162H163.027V140.541Z",
    fill: "#0B0C0D"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M185.514 140.541H179.892V146.162H185.514V140.541Z",
    fill: "#0B0C0D"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M191.135 140.541H185.514V146.162H191.135V140.541Z",
    fill: "#0B0C0D"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M196.757 140.541H191.135V146.162H196.757V140.541Z",
    fill: "#0B0C0D"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M208 140.541H202.378V146.162H208V140.541Z",
    fill: "#0B0C0D"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2432 146.162H5.62162V151.784H11.2432V146.162Z",
    fill: "#0B0C0D"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8649 146.162H11.2432V151.784H16.8649V146.162Z",
    fill: "#0B0C0D"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4865 146.162H16.8649V151.784H22.4865V146.162Z",
    fill: "#0B0C0D"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7297 146.162H28.1081V151.784H33.7297V146.162Z",
    fill: "#0B0C0D"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3514 146.162H33.7297V151.784H39.3514V146.162Z",
    fill: "#0B0C0D"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5946 146.162H44.973V151.784H50.5946V146.162Z",
    fill: "#0B0C0D"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8378 146.162H56.2162V151.784H61.8378V146.162Z",
    fill: "#0B0C0D"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4595 146.162H61.8378V151.784H67.4595L67.4595 146.162Z",
    fill: "#0B0C0D"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0811 146.162H67.4595L67.4595 151.784H73.0811V146.162Z",
    fill: "#0B0C0D"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9459 146.162H84.3243V151.784H89.946L89.9459 146.162Z",
    fill: "#0B0C0D"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5676 146.162H89.9459L89.946 151.784H95.5676V146.162Z",
    fill: "#0B0C0D"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M101.189 146.162H95.5676V151.784H101.189V146.162Z",
    fill: "#0B0C0D"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M106.811 146.162H101.189V151.784H106.811V146.162Z",
    fill: "#0B0C0D"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M118.054 146.162H112.432V151.784H118.054V146.162Z",
    fill: "#0B0C0D"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M140.541 146.162H134.919V151.784H140.541V146.162Z",
    fill: "#0B0C0D"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M146.162 146.162H140.541V151.784H146.162V146.162Z",
    fill: "#0B0C0D"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M151.784 146.162H146.162V151.784H151.784V146.162Z",
    fill: "#0B0C0D"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M157.405 146.162H151.784V151.784H157.405V146.162Z",
    fill: "#0B0C0D"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M196.757 146.162H191.135V151.784H196.757V146.162Z",
    fill: "#0B0C0D"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M208 146.162H202.378V151.784H208V146.162Z",
    fill: "#0B0C0D"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2432 151.784H5.62162V157.405H11.2432V151.784Z",
    fill: "#0B0C0D"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8649 151.784H11.2432V157.405H16.8649V151.784Z",
    fill: "#0B0C0D"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4865 151.784H16.8649V157.405H22.4865V151.784Z",
    fill: "#0B0C0D"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7297 151.784H28.1081V157.405H33.7297V151.784Z",
    fill: "#0B0C0D"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8378 151.784H56.2162V157.405H61.8378V151.784Z",
    fill: "#0B0C0D"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0811 151.784H67.4595L67.4595 157.405H73.0811V151.784Z",
    fill: "#0B0C0D"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3243 151.784H78.7027V157.405H84.3243L84.3243 151.784Z",
    fill: "#0B0C0D"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5676 151.784H89.946L89.9459 157.405H95.5676V151.784Z",
    fill: "#0B0C0D"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M106.811 151.784H101.189L101.189 157.405H106.811V151.784Z",
    fill: "#0B0C0D"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M112.432 151.784H106.811V157.405H112.432V151.784Z",
    fill: "#0B0C0D"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M118.054 151.784H112.432V157.405H118.054V151.784Z",
    fill: "#0B0C0D"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M129.297 151.784H123.676V157.405H129.297V151.784Z",
    fill: "#0B0C0D"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M151.784 151.784H146.162V157.405H151.784V151.784Z",
    fill: "#0B0C0D"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M163.027 151.784H157.405V157.405H163.027V151.784Z",
    fill: "#0B0C0D"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M168.649 151.784H163.027V157.405H168.649V151.784Z",
    fill: "#0B0C0D"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M179.892 151.784H174.27V157.405H179.892V151.784Z",
    fill: "#0B0C0D"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M185.514 151.784H179.892V157.405H185.514V151.784Z",
    fill: "#0B0C0D"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M196.757 151.784H191.135V157.405H196.757V151.784Z",
    fill: "#0B0C0D"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M202.378 151.784H196.757V157.405H202.378V151.784Z",
    fill: "#0B0C0D"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2432 157.405H5.62162V163.027H11.2432V157.405Z",
    fill: "#0B0C0D"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8649 157.405H11.2432V163.027H16.8649V157.405Z",
    fill: "#0B0C0D"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1081 157.405H22.4865V163.027H28.1081V157.405Z",
    fill: "#0B0C0D"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7297 157.405H28.1081V163.027H33.7297V157.405Z",
    fill: "#0B0C0D"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3514 157.405H33.7297V163.027H39.3514V157.405Z",
    fill: "#0B0C0D"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M44.973 157.405H39.3514V163.027H44.973V157.405Z",
    fill: "#0B0C0D"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2162 157.405H50.5946V163.027H56.2162V157.405Z",
    fill: "#0B0C0D"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8378 157.405H56.2162V163.027H61.8378V157.405Z",
    fill: "#0B0C0D"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7027 157.405H73.0811L73.0811 163.027H78.7027V157.405Z",
    fill: "#0B0C0D"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3243 157.405H78.7027V163.027H84.3243V157.405Z",
    fill: "#0B0C0D"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9459 157.405H84.3243V163.027H89.946L89.9459 157.405Z",
    fill: "#0B0C0D"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5676 157.405H89.9459L89.946 163.027H95.5676V157.405Z",
    fill: "#0B0C0D"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M101.189 157.405H95.5676V163.027H101.189L101.189 157.405Z",
    fill: "#0B0C0D"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M106.811 157.405H101.189L101.189 163.027H106.811V157.405Z",
    fill: "#0B0C0D"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M123.676 157.405H118.054V163.027H123.676V157.405Z",
    fill: "#0B0C0D"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M134.919 157.405H129.297V163.027H134.919V157.405Z",
    fill: "#0B0C0D"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M146.162 157.405H140.541V163.027H146.162V157.405Z",
    fill: "#0B0C0D"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M163.027 157.405H157.405V163.027H163.027V157.405Z",
    fill: "#0B0C0D"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M168.649 157.405H163.027V163.027H168.649V157.405Z",
    fill: "#0B0C0D"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M174.27 157.405H168.649V163.027H174.27V157.405Z",
    fill: "#0B0C0D"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M179.892 157.405H174.27V163.027H179.892V157.405Z",
    fill: "#0B0C0D"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M185.514 157.405H179.892V163.027H185.514V157.405Z",
    fill: "#0B0C0D"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M196.757 157.405H191.135V163.027H196.757V157.405Z",
    fill: "#0B0C0D"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M202.378 157.405H196.757V163.027H202.378V157.405Z",
    fill: "#0B0C0D"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0811 163.027H67.4595V168.649H73.0811L73.0811 163.027Z",
    fill: "#0B0C0D"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3243 163.027H78.7027V168.649H84.3243V163.027Z",
    fill: "#0B0C0D"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M89.946 163.027H84.3243V168.649H89.946V163.027Z",
    fill: "#0B0C0D"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5676 163.027H89.946V168.649H95.5676V163.027Z",
    fill: "#0B0C0D"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M101.189 163.027H95.5676V168.649H101.189V163.027Z",
    fill: "#0B0C0D"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M106.811 163.027H101.189V168.649H106.811V163.027Z",
    fill: "#0B0C0D"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M118.054 163.027H112.432V168.649H118.054V163.027Z",
    fill: "#0B0C0D"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M134.919 163.027H129.297V168.649H134.919V163.027Z",
    fill: "#0B0C0D"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M140.541 163.027H134.919V168.649H140.541V163.027Z",
    fill: "#0B0C0D"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M157.405 163.027H151.784V168.649H157.405V163.027Z",
    fill: "#0B0C0D"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M163.027 163.027H157.405V168.649H163.027V163.027Z",
    fill: "#0B0C0D"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M185.514 163.027H179.892V168.649H185.514V163.027Z",
    fill: "#0B0C0D"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M191.135 163.027H185.514V168.649H191.135V163.027Z",
    fill: "#0B0C0D"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M196.757 163.027H191.135V168.649H196.757V163.027Z",
    fill: "#0B0C0D"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M208 163.027H202.378V168.649H208V163.027Z",
    fill: "#0B0C0D"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62162 168.649H0V174.27H5.62162V168.649Z",
    fill: "#0B0C0D"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2432 168.649H5.62162V174.27H11.2432V168.649Z",
    fill: "#0B0C0D"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8649 168.649H11.2432V174.27H16.8649V168.649Z",
    fill: "#0B0C0D"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4865 168.649H16.8649V174.27H22.4865V168.649Z",
    fill: "#0B0C0D"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1081 168.649H22.4865V174.27H28.1081V168.649Z",
    fill: "#0B0C0D"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7297 168.649H28.1081V174.27H33.7297V168.649Z",
    fill: "#0B0C0D"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3514 168.649H33.7297V174.27H39.3514V168.649Z",
    fill: "#0B0C0D"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5946 168.649H44.973V174.27H50.5946V168.649Z",
    fill: "#0B0C0D"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8378 168.649H56.2162V174.27H61.8378V168.649Z",
    fill: "#0B0C0D"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4595 168.649H61.8378V174.27H67.4595L67.4595 168.649Z",
    fill: "#0B0C0D"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0811 168.649H67.4595L67.4595 174.27H73.0811V168.649Z",
    fill: "#0B0C0D"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3243 168.649H78.7027V174.27H84.3243V168.649Z",
    fill: "#0B0C0D"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M89.946 168.649H84.3243V174.27H89.946V168.649Z",
    fill: "#0B0C0D"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5676 168.649H89.946V174.27H95.5676V168.649Z",
    fill: "#0B0C0D"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M112.432 168.649H106.811V174.27H112.432V168.649Z",
    fill: "#0B0C0D"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M118.054 168.649H112.432V174.27H118.054V168.649Z",
    fill: "#0B0C0D"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M129.297 168.649H123.676V174.27H129.297V168.649Z",
    fill: "#0B0C0D"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M140.541 168.649H134.919V174.27H140.541V168.649Z",
    fill: "#0B0C0D"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M151.784 168.649H146.162V174.27H151.784V168.649Z",
    fill: "#0B0C0D"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M157.405 168.649H151.784V174.27H157.405V168.649Z",
    fill: "#0B0C0D"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M163.027 168.649H157.405V174.27H163.027V168.649Z",
    fill: "#0B0C0D"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M174.27 168.649H168.649V174.27H174.27V168.649Z",
    fill: "#0B0C0D"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M185.514 168.649H179.892V174.27H185.514V168.649Z",
    fill: "#0B0C0D"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M191.135 168.649H185.514V174.27H191.135V168.649Z",
    fill: "#0B0C0D"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M202.378 168.649H196.757V174.27H202.378V168.649Z",
    fill: "#0B0C0D"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M208 168.649H202.378V174.27H208V168.649Z",
    fill: "#0B0C0D"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62162 174.27H0V179.892H5.62162V174.27Z",
    fill: "#0B0C0D"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3514 174.27H33.7297V179.892H39.3514V174.27Z",
    fill: "#0B0C0D"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5946 174.27H44.973V179.892H50.5946V174.27Z",
    fill: "#0B0C0D"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2162 174.27H50.5946V179.892H56.2162V174.27Z",
    fill: "#0B0C0D"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0811 174.27H67.4595L67.4595 179.892H73.0811V174.27Z",
    fill: "#0B0C0D"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7027 174.27H73.0811V179.892H78.7027V174.27Z",
    fill: "#0B0C0D"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3243 174.27H78.7027V179.892H84.3243V174.27Z",
    fill: "#0B0C0D"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M89.946 174.27H84.3243V179.892H89.946V174.27Z",
    fill: "#0B0C0D"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5676 174.27H89.946V179.892H95.5676V174.27Z",
    fill: "#0B0C0D"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M101.189 174.27H95.5676V179.892H101.189V174.27Z",
    fill: "#0B0C0D"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M112.432 174.27H106.811V179.892H112.432V174.27Z",
    fill: "#0B0C0D"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M129.297 174.27H123.676V179.892H129.297V174.27Z",
    fill: "#0B0C0D"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M134.919 174.27H129.297V179.892H134.919V174.27Z",
    fill: "#0B0C0D"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M151.784 174.27H146.162V179.892H151.784V174.27Z",
    fill: "#0B0C0D"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M157.405 174.27H151.784V179.892H157.405V174.27Z",
    fill: "#0B0C0D"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M163.027 174.27H157.405V179.892H163.027V174.27Z",
    fill: "#0B0C0D"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M185.514 174.27H179.892V179.892H185.514V174.27Z",
    fill: "#0B0C0D"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62162 179.892H0V185.514H5.62162V179.892Z",
    fill: "#0B0C0D"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8649 179.892H11.2432V185.514H16.8649V179.892Z",
    fill: "#0B0C0D"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4865 179.892H16.8649V185.514H22.4865V179.892Z",
    fill: "#0B0C0D"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1081 179.892H22.4865V185.514H28.1081V179.892Z",
    fill: "#0B0C0D"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3514 179.892H33.7297V185.514H39.3514V179.892Z",
    fill: "#0B0C0D"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5946 179.892H44.973V185.514H50.5946V179.892Z",
    fill: "#0B0C0D"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0811 179.892H67.4595V185.514H73.0811V179.892Z",
    fill: "#0B0C0D"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3243 179.892H78.7027V185.514H84.3243V179.892Z",
    fill: "#0B0C0D"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M89.946 179.892H84.3243V185.514H89.946V179.892Z",
    fill: "#0B0C0D"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5676 179.892H89.946V185.514H95.5676V179.892Z",
    fill: "#0B0C0D"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M106.811 179.892H101.189L101.189 185.514H106.811V179.892Z",
    fill: "#0B0C0D"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M112.432 179.892H106.811V185.514H112.432V179.892Z",
    fill: "#0B0C0D"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M118.054 179.892H112.432V185.514H118.054V179.892Z",
    fill: "#0B0C0D"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M129.297 179.892H123.676V185.514H129.297V179.892Z",
    fill: "#0B0C0D"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M134.919 179.892H129.297V185.514H134.919V179.892Z",
    fill: "#0B0C0D"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M140.541 179.892H134.919V185.514H140.541V179.892Z",
    fill: "#0B0C0D"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M157.405 179.892H151.784V185.514H157.405V179.892Z",
    fill: "#0B0C0D"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M163.027 179.892H157.405V185.514H163.027V179.892Z",
    fill: "#0B0C0D"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M168.649 179.892H163.027V185.514H168.649V179.892Z",
    fill: "#0B0C0D"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M174.27 179.892H168.649V185.514H174.27V179.892Z",
    fill: "#0B0C0D"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M179.892 179.892H174.27V185.514H179.892V179.892Z",
    fill: "#0B0C0D"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M185.514 179.892H179.892V185.514H185.514V179.892Z",
    fill: "#0B0C0D"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M191.135 179.892H185.514V185.514H191.135V179.892Z",
    fill: "#0B0C0D"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M202.378 179.892H196.757V185.514H202.378V179.892Z",
    fill: "#0B0C0D"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M208 179.892H202.378V185.514H208V179.892Z",
    fill: "#0B0C0D"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62162 185.514H0V191.135H5.62162V185.514Z",
    fill: "#0B0C0D"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8649 185.514H11.2432V191.135H16.8649V185.514Z",
    fill: "#0B0C0D"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4865 185.514H16.8649V191.135H22.4865V185.514Z",
    fill: "#0B0C0D"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1081 185.514H22.4865V191.135H28.1081V185.514Z",
    fill: "#0B0C0D"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3514 185.514H33.7297V191.135H39.3514V185.514Z",
    fill: "#0B0C0D"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5946 185.514H44.973V191.135H50.5946V185.514Z",
    fill: "#0B0C0D"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8378 185.514H56.2162V191.135H61.8378V185.514Z",
    fill: "#0B0C0D"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4595 185.514H61.8378V191.135H67.4595L67.4595 185.514Z",
    fill: "#0B0C0D"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3243 185.514H78.7027V191.135H84.3243V185.514Z",
    fill: "#0B0C0D"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M118.054 185.514H112.432V191.135H118.054V185.514Z",
    fill: "#0B0C0D"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M123.676 185.514H118.054V191.135H123.676V185.514Z",
    fill: "#0B0C0D"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M129.297 185.514H123.676V191.135H129.297V185.514Z",
    fill: "#0B0C0D"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M146.162 185.514H140.541V191.135H146.162V185.514Z",
    fill: "#0B0C0D"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M163.027 185.514H157.405V191.135H163.027V185.514Z",
    fill: "#0B0C0D"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M168.649 185.514H163.027V191.135H168.649V185.514Z",
    fill: "#0B0C0D"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M179.892 185.514H174.27V191.135H179.892V185.514Z",
    fill: "#0B0C0D"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M208 185.514H202.378V191.135H208V185.514Z",
    fill: "#0B0C0D"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62162 191.135H0V196.757H5.62162V191.135Z",
    fill: "#0B0C0D"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8649 191.135H11.2432V196.757H16.8649V191.135Z",
    fill: "#0B0C0D"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4865 191.135H16.8649V196.757H22.4865V191.135Z",
    fill: "#0B0C0D"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1081 191.135H22.4865V196.757H28.1081V191.135Z",
    fill: "#0B0C0D"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3514 191.135H33.7297V196.757H39.3514V191.135Z",
    fill: "#0B0C0D"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5946 191.135H44.973V196.757H50.5946V191.135Z",
    fill: "#0B0C0D"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0811 191.135H67.4595L67.4595 196.757H73.0811V191.135Z",
    fill: "#0B0C0D"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5676 191.135H89.9459V196.757H95.5676V191.135Z",
    fill: "#0B0C0D"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M101.189 191.135H95.5676V196.757H101.189V191.135Z",
    fill: "#0B0C0D"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M118.054 191.135H112.432V196.757H118.054V191.135Z",
    fill: "#0B0C0D"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M140.541 191.135H134.919V196.757H140.541V191.135Z",
    fill: "#0B0C0D"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M151.784 191.135H146.162V196.757H151.784V191.135Z",
    fill: "#0B0C0D"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M163.027 191.135H157.405V196.757H163.027V191.135Z",
    fill: "#0B0C0D"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M174.27 191.135H168.649V196.757H174.27V191.135Z",
    fill: "#0B0C0D"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M185.514 191.135H179.892V196.757H185.514V191.135Z",
    fill: "#0B0C0D"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M191.135 191.135H185.514V196.757H191.135V191.135Z",
    fill: "#0B0C0D"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M196.757 191.135H191.135V196.757H196.757V191.135Z",
    fill: "#0B0C0D"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M208 191.135H202.378V196.757H208V191.135Z",
    fill: "#0B0C0D"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62162 196.757H0V202.378H5.62162V196.757Z",
    fill: "#0B0C0D"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3514 196.757H33.7297V202.378H39.3514V196.757Z",
    fill: "#0B0C0D"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2162 196.757H50.5946V202.378H56.2162V196.757Z",
    fill: "#0B0C0D"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8378 196.757H56.2162V202.378H61.8378V196.757Z",
    fill: "#0B0C0D"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0811 196.757H67.4595V202.378H73.0811V196.757Z",
    fill: "#0B0C0D"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3243 196.757H78.7027V202.378H84.3243V196.757Z",
    fill: "#0B0C0D"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9459 196.757H84.3243V202.378H89.946L89.9459 196.757Z",
    fill: "#0B0C0D"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M101.189 196.757H95.5676L95.5676 202.378H101.189V196.757Z",
    fill: "#0B0C0D"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M106.811 196.757H101.189V202.378H106.811V196.757Z",
    fill: "#0B0C0D"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M129.297 196.757H123.676V202.378H129.297V196.757Z",
    fill: "#0B0C0D"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M134.919 196.757H129.297V202.378H134.919V196.757Z",
    fill: "#0B0C0D"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M140.541 196.757H134.919V202.378H140.541V196.757Z",
    fill: "#0B0C0D"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M151.784 196.757H146.162V202.378H151.784V196.757Z",
    fill: "#0B0C0D"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M163.027 196.757H157.405V202.378H163.027V196.757Z",
    fill: "#0B0C0D"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M168.649 196.757H163.027V202.378H168.649V196.757Z",
    fill: "#0B0C0D"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M179.892 196.757H174.27V202.378H179.892V196.757Z",
    fill: "#0B0C0D"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M196.757 196.757H191.135V202.378H196.757V196.757Z",
    fill: "#0B0C0D"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M208 196.757H202.378V202.378H208V196.757Z",
    fill: "#0B0C0D"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62162 202.378H0V208H5.62162V202.378Z",
    fill: "#0B0C0D"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2432 202.378H5.62162V208H11.2432V202.378Z",
    fill: "#0B0C0D"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8649 202.378H11.2432V208H16.8649V202.378Z",
    fill: "#0B0C0D"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4865 202.378H16.8649V208H22.4865V202.378Z",
    fill: "#0B0C0D"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1081 202.378H22.4865V208H28.1081V202.378Z",
    fill: "#0B0C0D"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7297 202.378H28.1081V208H33.7297V202.378Z",
    fill: "#0B0C0D"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3514 202.378H33.7297V208H39.3514V202.378Z",
    fill: "#0B0C0D"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8378 202.378H56.2162V208H61.8378V202.378Z",
    fill: "#0B0C0D"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4595 202.378H61.8378V208H67.4595L67.4595 202.378Z",
    fill: "#0B0C0D"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0811 202.378H67.4595L67.4595 208H73.0811V202.378Z",
    fill: "#0B0C0D"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3243 202.378H78.7027V208H84.3243V202.378Z",
    fill: "#0B0C0D"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M89.946 202.378H84.3243V208H89.946V202.378Z",
    fill: "#0B0C0D"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M106.811 202.378H101.189L101.189 208H106.811V202.378Z",
    fill: "#0B0C0D"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M112.432 202.378H106.811V208H112.432V202.378Z",
    fill: "#0B0C0D"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M129.297 202.378H123.676V208H129.297V202.378Z",
    fill: "#0B0C0D"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M151.784 202.378H146.162V208H151.784V202.378Z",
    fill: "#0B0C0D"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M157.405 202.378H151.784V208H157.405V202.378Z",
    fill: "#0B0C0D"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M163.027 202.378H157.405V208H163.027V202.378Z",
    fill: "#0B0C0D"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M174.27 202.378H168.649V208H174.27V202.378Z",
    fill: "#0B0C0D"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M185.514 202.378H179.892V208H185.514V202.378Z",
    fill: "#0B0C0D"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M191.135 202.378H185.514V208H191.135V202.378Z",
    fill: "#0B0C0D"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M196.757 202.378H191.135V208H196.757V202.378Z",
    fill: "#0B0C0D"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M202.378 202.378H196.757V208H202.378V202.378Z",
    fill: "#0B0C0D"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M208 202.378H202.378V208H208V202.378Z",
    fill: "#0B0C0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrGoogle);
export default __webpack_public_path__ + "static/media/qr-google.6315c78e159e40f48c49a6aaa37a3e3a.svg";
export { ForwardRef as ReactComponent };